module.exports = __webpack_public_path__ + "img/print.126be1b1.svg";